import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import QuestsPage from "../pages/quests/page";
import QuestDetailPage from "../pages/quests/detail/page";
import QuestCreatePage from "../pages/quests/create/page";
import QuestNewPage from "../pages/quests/new/page";
import ArtistsPage from "../pages/artists/page";
import ArtistDetailPage from "../pages/artists/detail/page";
import CommunityPage from "../pages/community/page";
import InteractionPage from "../pages/interaction/page";
import PricingPage from "../pages/pricing/page";
import SignupPage from "../pages/signup/page";
import LoginPage from "../pages/login/page";
import MyPage from "../pages/mypage/page";
import ArtistRegisterPage from "../pages/artist-register/page";
import RewardsPage from "../pages/rewards/page";
import RewardManagePage from "../pages/rewards/manage/page";
import ArtistRewardsPage from "../pages/rewards/artist/page";
import BrandsPage from "../pages/brands/page";
import BrandDetailPage from "../pages/brands/detail/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/artists", element: <ArtistsPage /> },
  { path: "/artists/:artistId", element: <ArtistDetailPage /> },
  { path: "/quests", element: <QuestsPage /> },
  { path: "/quests/new", element: <QuestNewPage /> },
  { path: "/quests/:questId", element: <QuestDetailPage /> },
  { path: "/quests/:questId/create", element: <QuestCreatePage /> },
  { path: "/community", element: <CommunityPage /> },
  { path: "/interaction", element: <InteractionPage /> },
  { path: "/pricing", element: <PricingPage /> },
  { path: "/signup", element: <SignupPage /> },
  { path: "/login", element: <LoginPage /> },
  { path: "/mypage", element: <MyPage /> },
  { path: "/artist-register", element: <ArtistRegisterPage /> },
  { path: "/rewards", element: <RewardsPage /> },
  { path: "/rewards/manage", element: <RewardManagePage /> },
  { path: "/rewards/:artistId", element: <ArtistRewardsPage /> },
  { path: "/brands", element: <BrandsPage /> },
  { path: "/brands/:brandId", element: <BrandDetailPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
